import React from 'react';
import {
    TextInput,
    NumberInput,
    required,
    Create,
    SimpleForm,
    ReferenceInput,
    SelectInput,
    Edit,
    NumberField,
    TextField,
    ReferenceField,
    FunctionField,
    Show,
    SimpleShowLayout,
    usePermissions
} from 'react-admin';
import { Redirect } from 'react-router-dom';
import {
    TopToolbar,
    sanitizeListRestProps,
    EditButton
} from 'react-admin';
import { parse } from "query-string";
import DeletePriceButtonWithConfirmation from '../buttons/deletePriceButtonWithConfirmation'

const redirect = (basePath, id, data) => `/cost_centers/${data.costId}/show`;

export const PriceCreate = props => {
    const { costId: cost_id } = parse(props.location.search);
    const costId = cost_id ? parseInt(cost_id, 10) : "";
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if (!permissions.includes("machine_types.list") || !permissions.includes("cost_centers.list")) {
        return <Redirect to="/401" />
    }
    return (
        <Create {...props}>
            <SimpleForm defaultValue={{ costId }} submitOnEnter={false} redirect={redirect}>
                <TextInput validate={[required()]} source="type" label='Nombre' />
                <NumberInput validate={[required()]} source="price" label='Precio' step={100} min={100} />
                <NumberInput source="pricePeakHour" label='Precio hora punta' step={100} min={100} />
                {permissions.includes("machine_types.list") &&
                    <ReferenceInput validate={[required()]} source="machineId" label='Tipo de máquina' reference="machine_types" perPage={200}
                        sort={{ field: 'id', order: 'ASC' }}
                    >
                        <SelectInput optionText={record => `${record.type} - ${record.secondType}`} />
                    </ReferenceInput>
                }
                {permissions.includes("cost_centers.list") &&
                    <ReferenceInput validate={[required()]} source="costId" label='Centro de costo' reference="cost_centers" perPage={200}
                        sort={{ field: 'name', order: 'ASC' }}
                    >
                        <SelectInput optionText={record => `${record.name}`} />
                    </ReferenceInput>
                }
                <NumberInput validate={[required()]} source="defaultMinutes" label='Duración' step={1} min={1} max={120} />
                <NumberInput validate={[required()]} source="ticks" label='Ticks' step={1} min={1} max={20} />
                <NumberInput validate={[required()]} source="position" label='Posición' step={1} min={1} max={100} />
                <NumberInput validate={[required()]} source="minutePrice" label='4 minutos' defaultValue={0} min={0} step={100} />
            </SimpleForm>
        </Create>
    )
}

export const PriceEdit = props => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if (!permissions.includes("machine_types.list") || !permissions.includes("cost_centers.list")) {
        return <Redirect to="/401" />
    }
    return (
        <Edit {...props}>
            <SimpleForm submitOnEnter={false} redirect={redirect}>
                <TextInput validate={[required()]} source="type" label='Nombre' />
                <NumberInput validate={[required()]} source="price" label='Precio' step={100} min={100} />
                <NumberInput source="pricePeakHour" label='Precio hora punta' step={100} min={100}/>
                {permissions.includes("machine_types.list") &&
                    <ReferenceInput disabled={true} validate={[required()]} source="machineId" label='Tipo de máquina' reference="machine_types" perPage={200}
                        sort={{ field: 'id', order: 'ASC' }}
                    >
                        <SelectInput optionText={record => `${record.type} - ${record.secondType}`} />
                    </ReferenceInput>
                }
                {permissions.includes("cost_centers.list") &&
                    <ReferenceInput disabled={true} validate={[required()]} source="costId" label='Centro de costo' reference="cost_centers" perPage={200}
                        sort={{ field: 'name', order: 'ASC' }}
                    >
                        <SelectInput optionText={record => `${record.name}`} />
                    </ReferenceInput>
                }
                <NumberInput validate={[required()]} source="defaultMinutes" label='Duración' step={1} min={1} max={120} />
                <NumberInput validate={[required()]} source="ticks" label='Ticks' step={1} min={1} max={20} />
                <NumberInput validate={[required()]} source="position" label='Posición' step={1} min={1} max={100} />
                <NumberInput validate={[required()]} source="minutePrice" label='4 minutos' defaultValue={0} min={0} step={100} />
            </SimpleForm>
        </Edit>
    )
}

const ShowActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        basePath,
        data,
        resource,
        ...rest
    } = props;
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {permissions.includes("prices.edit") && <EditButton basePath={basePath} record={data} label="Editar" />}
            {permissions.includes("prices.delete") && <DeletePriceButtonWithConfirmation basePath={basePath} record={data} resource={resource} undoable={false} label="Eliminar" />}
        </TopToolbar>
    );
};

export const PriceShow = props => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <Show {...props} actions={<ShowActions />}>
            <SimpleShowLayout>
                <TextField source="type" label='Nombre' />
                <NumberField source="price" label='Precio' step={100} min={100} />
                <NumberField source="pricePeakHour" label="Precio hora punta" step={100} min={100}/>
                {permissions.includes("machine_types.list") &&
                    <ReferenceField source="machineId" label='Tipo de máquina' reference="machine_types" perPage={200}
                        sort={{ field: 'id', order: 'ASC' }}
                    >
                        <FunctionField render={record => `${record.type} - ${record.secondType}`} />
                    </ReferenceField>
                }
                {permissions.includes("cost_centers.list") &&
                    <ReferenceField source="costId" label='Centro de costo' reference="cost_centers" perPage={200}
                        sort={{ field: 'name', order: 'ASC' }}
                    >
                        <FunctionField render={record => `${record.name}`} />
                    </ReferenceField>
                }
                <NumberField source="defaultMinutes" label='Duración' step={1} min={1} max={120} />
                <NumberField source="ticks" label='Ticks' step={1} min={1} max={20} />
                <NumberField source="position" label='Posición' step={1} min={1} max={100} />
                <NumberField source="minutePrice" label='4 minutos' defaultValue={0} min={0} step={100} />
            </SimpleShowLayout>
        </Show>
    )
}
